// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__17Ll2","content":"Modal_content__3uzxA","close-modal":"Modal_close-modal__aZhkA","opened":"Modal_opened__AKK9P","open-modal":"Modal_open-modal__3p9Ot"};